import { createContext } from "react";

export type ApprovalContextType = {
  isImageLoading: boolean,
  setImageLoader: (val: boolean) => void
}

export const ApprovalContext = createContext<ApprovalContextType>({
  isImageLoading: false,
  setImageLoader: () => {}
})
